






















































































































































































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import axios from 'axios'
import VueQrcode from 'vue-qrcode'
import { TranslateResult } from 'vue-i18n'

export default Vue.extend({
  name: 'v-test-badge',

  components: {
    'c-vue-qrcode': VueQrcode
  },

  data () {
    return {
      getEntities: {
        isStand: true,
        isProduct: true,
        isStandman: true,
        isVisitor: true
      },
      testScans: {
        isVisitor: false,
        isStandman: false,
        isTimeRange: false,
      },
      entityType: null as null | 'product' | 'stand' | 'visitor' | 'product' | 'standman',
      entityData: {
        name: null
      } as any,
      imgURL: null as null | string,
      barcode: null,
      standmans: [] as any[],
      selectedStandman: null,
      loading: true,

      modals: {
        deleteTestData: false,
        deleteTestDataSuccess: false,
        deleteTestDataFailed: false
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['showId']),
    ...mapGetters('profile', ['profiles']),

    isBtnActive (): boolean {
      return !(
        this.getEntities.isVisitor ||
        this.getEntities.isStand ||
        this.getEntities.isStandman ||
        this.getEntities.isProduct
      )
    },

    isQRCode (): boolean {
      return this.entityType === 'product' || this.entityType === 'stand'
    },

    scanImageTitle (): TranslateResult {
      if (this.entityType == 'visitor') return this.$t('test.scanImageTitles.visitor')
      else if (this.entityType == 'product') return this.$t('test.scanImageTitles.product')
      else if (this.entityType == 'standman') return this.$t('test.scanImageTitles.standman')

      return this.$t('test.scanImageTitles.stand')
    },

    isScanBtnActive (): boolean {
      return !(this.testScans.isVisitor || this.testScans.isStandman)
    },

    standManCaption (): TranslateResult {
      if (this.entityType === 'visitor') {
        return this.$t('test.visitor')
      }

      return this.$t('test.standman')
    }
  },

  mounted() {
    this.standmans = this.profiles.map((profile: any) => {
      return {
        value: profile._id,
        text: `${profile.name.last} ${profile.name.first} `
      }
    })
    this.selectedStandman = this.standmans[0].value
    this.getEntity()
  },

  methods: {
    async getEntity() {
      this.loading = true

      const req = await axios({
        url: "/test/get-entity",
        method: "POST",
        data: {
          showId: this.showId,
          is_visitor: this.getEntities.isVisitor,
          is_standman: this.getEntities.isStandman,
          is_stand: this.getEntities.isStand,
          is_product: this.getEntities.isProduct
        }
      })
      const res = req.data

      if (res.role == 'visitor') {
        this.entityType = 'visitor'
        this.barcode = res.barcode
        this.entityData.companyTitle = res.companyTitle
        this.entityData.name = `${res.name.first} ${res.name.last}`
      } else if (res.vendorCode) {
        this.imgURL = `https://lfqr.cc/e/${this.showId}/p/${res._id}`
        this.entityType = 'product'
        this.entityData.vendorCode = res.vendorCode
        this.entityData.title = res.title
      } else if (res.role === 'standman') {
        this.entityType = 'standman'
        this.barcode = res.barcode
        this.entityData.companyTitle = res.companyTitle
        this.entityData.name = `${res.name.first} ${res.name.last}`
      } else {
        this.imgURL = `https://lfqr.cc/e/${res._show}/s/${res.title}`
        this.entityType = 'stand'
        this.entityData.title = res.title
      }

      setTimeout(() => {
        this.loading = false
      }, 300)
    },

    async testScan(count: number) {
      const target_id = this.selectedStandman;

      await axios({
        url: '/test/scan',
        method: 'POST',
        data: {
          is_visitor: this.testScans.isVisitor,
          is_standman: this.testScans.isStandman,
          is_time_range: this.testScans.isTimeRange,
          target_id,
          count
        }
      })
    },

    async removeScans() {
      this.modals.deleteTestData = false

      try {
        await axios({
          url: 'test/remove-scan',
          method: 'POST',
          data: {
            target_id: this.standmans.map((standman: any) => standman.value),
          }
        })

        this.modals.deleteTestDataSuccess = true
      } catch (error) {
        this.modals.deleteTestDataFailed = true
        console.error(error)
      }
    }
  }
})
